import React from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Skeleton,
  Box,
  CardActions,
} from '@mui/material';

interface CardGridSkeletonProps {
  items?: number;
  hasImage?: boolean;
  hasActions?: boolean;
}

export function CardGridSkeleton({
  items = 6,
  hasImage = true,
  hasActions = true
}: CardGridSkeletonProps) {
  const itemsArray = Array.from({ length: items }, (_, i) => i);

  return (
    <Grid container spacing={3}>
      {itemsArray.map((index) => (
        <Grid item xs={12} sm={6} md={4} key={`skeleton-${index}`}>
          <Card
            elevation={3}
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {hasImage && (
              <Skeleton
                variant="rectangular"
                height={200}
                sx={{ bgcolor: 'action.hover' }}
              />
            )}
            <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ mb: 1 }}>
                <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 2 }} />
              </Box>
              <Skeleton variant="text" width="90%" height={32} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="95%" height={20} />
              <Skeleton variant="text" width="85%" height={20} />
              <Skeleton variant="text" width="60%" height={20} sx={{ mb: 2 }} />
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mt: 'auto',
                }}
              >
                <Skeleton variant="circular" width={16} height={16} />
                <Skeleton variant="text" width={100} height={20} />
              </Box>
            </CardContent>
            {hasActions && (
              <CardActions sx={{ justifyContent: 'space-between', px: 2, pb: 2 }}>
                <Skeleton variant="circular" width={32} height={32} />
                <Skeleton variant="circular" width={32} height={32} />
              </CardActions>
            )}
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
